module.exports = "/fast-coin/img/coin/anim/out_1/out_1_004.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/out_1/out_1_004.png
// module id = 2300
// module chunks = 5